import { isPlatform } from "@ionic/react";
import { AppVersion } from "@awesome-cordova-plugins/app-version";
import { IONICWrapper } from "../common";
import {
  AB_TEST_KEYS,
  FirebaseRemoteConfiguration,
  KEYS
} from "../constants";
import "firebase/remote-config";
import app from "firebase/app";
import {RemoteConfigDataStore} from "./RemoteConfigHandler";
import { RemoteConfig } from "fpc-custom-plugin-firebase-remote-config";

export const enableRemoteConfig = (callback: Function) => {
  if (isPlatform("capacitor")) {
    RemoteConfig.initialize({
      minimumFetchIntervalInSeconds: KEYS.minimumFetchIntervalInSec
    });
  } else {
    // Initialize Remote Config and get a reference to the service
    const remoteConfig = app.remoteConfig();
    remoteConfig.settings.minimumFetchIntervalMillis = 60000;
    rcWebFetchAndActivate(remoteConfig);
    setInterval(() => {
      rcWebFetchAndActivate(remoteConfig);
    }, 60000);
  }

  const isLesserVersion = ({
    appVersionNumber = "",
    minimumVersion = ""
  }: {
    appVersionNumber: string;
    minimumVersion: string;
  }) => {
    if (appAndMinimumVersionCheck(appVersionNumber, minimumVersion)) {
      return false;
    }

    let appVersionArray: number[] = [];
    let minimumVersionArray: number[] = [];

    appVersionNumber
      .split(".")
      .forEach(element => appVersionArray.push(parseInt(element)));
    minimumVersion
      .split(".")
      .forEach(element => minimumVersionArray.push(parseInt(element)));

    const isMajorVersionChange = appVersionArray[0] < minimumVersionArray[0];
    const isMinorPatchVersionChange =
      appVersionArray[1] < minimumVersionArray[1];
    const isBuildVersionChange = appVersionArray[2] < minimumVersionArray[2];
    if (isMajorVersionChange) {
      return true;
    } else if (majorVersionChangeCheck(isMajorVersionChange, isMinorPatchVersionChange)) {
      return true;
    } else if (buildVersionChange(isMajorVersionChange, isMinorPatchVersionChange, isBuildVersionChange)) {
      getAppVersionCompare(appVersionArray,minimumVersionArray);
    } else {
      return false;
    }
  };
  RemoteConfig.fetchAndActivate()
    .then(() => {
      RemoteConfig.getString({
        key: FirebaseRemoteConfiguration.REMOTECONFIG_STORE_VERSION
      }).then((response: any) => {
        const data = getResponseData(response);
        AppVersion.getVersionNumber().then(function(appVersionNumber) {
          const isOldVersion = isLesserVersion({
            appVersionNumber,
            minimumVersion: data.minimumVersion
          });

          callback({
            status:versionCheck(isOldVersion, data, appVersionNumber),
            forceUpdate: oldVersionCheck(isOldVersion, data),
            title: data.title,
            optionalUpdateMessage: data.optionalUpdateMessage,
            forceUpdateMessage: data.forceUpdateMessage
          });
        });
      });

      AB_TEST_KEYS.forEach((abTestkey) => {
        RemoteConfig.getString({ key: abTestkey }).then((response: any) => {
          const data = getResponseData(response);
            IONICWrapper.details.setKeyValuePairs = { ...data };
        });
      });
    }).catch((err: any) => null);
};

const rcWebFetchAndActivate = async (remoteConfig: any) => {
  remoteConfig.fetchAndActivate().then(async () => {
    await RemoteConfigDataStore(remoteConfig);
  });
};

function oldVersionCheck(isOldVersion: boolean | undefined, data: any) {
  return isOldVersion
    ? true
    : (data && data.forceUpdate) || false;
}

function versionCheck(isOldVersion: boolean|undefined, data: any, appVersionNumber: string) {
  return isOldVersion ||
    data.forceUpdate ||
    (data.show && data.version !== appVersionNumber);
}

function appAndMinimumVersionCheck(appVersionNumber: string, minimumVersion: string) {
  return !appVersionNumber && !minimumVersion;
}

function getResponseData(response: any) {
  return response && response.value && typeof response.value === "string"
    ? JSON.parse(response.value)
    : response.value;
}

function buildVersionChange(isMajorVersionChange: boolean, isMinorPatchVersionChange: boolean, isBuildVersionChange: boolean) {
  return !isMajorVersionChange &&
    !isMinorPatchVersionChange &&
    isBuildVersionChange;
}

function majorVersionChangeCheck(isMajorVersionChange: boolean, isMinorPatchVersionChange: boolean) {
  return !isMajorVersionChange && isMinorPatchVersionChange;
}
function getAppVersionCompare(appVersionArray:number[],minimumVersionArray:number[])
{
  if (appVersionArray[1] == minimumVersionArray[1]) {
    return true;
  } else {
    return false;
  }
}